"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Text;

var _react = _interopRequireDefault(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-text";
/*---------------------------------------------*/

function Text(props) {
  var customClasses = [];
  customClasses.push(BASE_CLASS + "--" + (props.size || "regular"));
  props.bold && customClasses.push(BASE_CLASS + "--bold");
  var color = props.color;

  if (color && color.startsWith("--")) {
    color = "var(".concat(color.replace("--", "--color-"), ")");
  }

  var customStyle = {};

  if (color) {
    customStyle.color = color;
  }

  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS, customClasses);
  var style = (0, _useStyleBuilder.default)(props, customStyle);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: classes,
    style: style
  }, props.children);
}
/*---------------------------------------------*/


Text.METADATA = {
  name: "Text",
  props: [{
    name: "size",
    type: "string",
    default: "regular",
    options: [{
      value: "xsmall",
      label: "Extra Small"
    }, {
      value: "small",
      label: "Small"
    }, {
      value: "regular",
      label: "Regular"
    }, {
      value: "large",
      label: "Large"
    }]
  }, {
    name: "bold",
    type: "boolean"
  }, {
    name: "color",
    type: "string"
  }],
  demo: {
    content: "Body text example"
  }
};